import React, { useEffect, useState } from "react";
import { Button, Form, Input, InputNumber, Space } from "antd";
import "./edit_table_purchase_order.css";

interface DataType {
    key: React.Key;
    pr_no: string;
    so_no: string;
    item_code: string;
    item_name: string;
    uom: string;
    uom_rate: number;
    qty: number;
    price: number;
    discount: number;
    discount_amount: number;
    total: number;
    remark?: string;
    pr_line?: number;
    warehouse?: string;
}

interface EditTablePurchaseOrderProps {
    record: DataType | null;
    onOk: (values: DataType) => void;
    onCancel: () => void;
}

const EditTablePurchaseOrder: React.FC<EditTablePurchaseOrderProps> = ({ record, onOk, onCancel }) => {
    const [form] = Form.useForm();
    const [isDiscountDisabled, setIsDiscountDisabled] = useState(false);

    useEffect(() => {
        if (record) {
            const price = record.price || 0;
            const qty = record.qty || 0;
            const discount = record.discount || 0;
            const subTotal = price * qty;
            const discountAmount = subTotal * (discount / 100);
            const total = subTotal - discountAmount;

            form.setFieldsValue({
                ...record,
                sub_total: subTotal,
                discount_amount: discountAmount,
                total: total,
                remark: record.remark,
            });

            form.setFieldsValue({
                ...record,
                sub_total: subTotal,
                discount_amount: discountAmount,
                total: total,
            });

            setIsDiscountDisabled(false);
        } else {
            form.resetFields();
            setIsDiscountDisabled(false);
        }
    }, [record, form]);



    const handleValuesChange = (changedValues: any, allValues: any) => {
        const price = allValues.price || 0;
        const qty = allValues.qty || 0;
        const subTotal = price * qty;

        let discountAmount = allValues.discount_amount || 0;


        if ('discount_amount' in changedValues) {
            const newDiscountAmount = changedValues.discount_amount;
            if (newDiscountAmount && newDiscountAmount >= 1) {
                setIsDiscountDisabled(true);
                const calculatedDiscountPercent = subTotal > 0 ? (newDiscountAmount / subTotal) * 100 : 0;
                form.setFieldsValue({ discount: calculatedDiscountPercent });
                discountAmount = newDiscountAmount;
            } else {
                setIsDiscountDisabled(false);
                form.setFieldsValue({ discount: 0 });
                discountAmount = 0;
            }
        }

        else if ('discount' in changedValues && !isDiscountDisabled) {
            const discount = changedValues.discount || 0;
            discountAmount = subTotal * (discount / 100);
        }

        else if ('price' in changedValues || 'qty' in changedValues) {
            if (!isDiscountDisabled) {
                const discount = allValues.discount || 0;
                discountAmount = subTotal * (discount / 100);
            }

        }

        const total = subTotal - discountAmount;

        form.setFieldsValue({
            sub_total: subTotal,
            discount_amount: discountAmount,
            total: total,
        });
    };

    const handleFinish = (values: any) => {
        const subTotal = values.sub_total || 0;
        const discountAmount = values.discount_amount || 0;
        let finalValues = { ...values };

        if (subTotal > 0 && discountAmount > 0) {
            const calculatedDiscount = (discountAmount / subTotal) * 100;
            finalValues.discount = calculatedDiscount;
        }

        onOk(finalValues);
    };


    const numberFormatter = (value: number | string | undefined) => {
        if (!value) return '0';
        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const numberParser = (value: string | undefined) => {
        if (!value) return 0;
        return Number(value.replace(/,/g, ''));
    };

    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    return (

        <div id="ilqt" style={transformStyle}>
            <div className="gjs-grid-row" id="izlv">
                <div className="gjs-grid-column" id="ieu9">

                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                        onFinish={handleFinish}
                        onValuesChange={handleValuesChange}
                    >

                        <Form.Item label="Item Code" name="item_code" style={{ marginBottom: "5px" }}>
                            <Input disabled />
                        </Form.Item>
                        <Form.Item
                            label="Item Name"
                            name="item_name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="PR No"
                            name="pr_no"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled />
                        </Form.Item>
                        <Form.Item
                            label="SO No"
                            name="so_no"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled />
                        </Form.Item>
                        <Form.Item
                            label="PR Line"
                            name="pr_line"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled />
                        </Form.Item>
                        <Form.Item
                            label="UoM"
                            name="uom"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="UoM Rate"
                            name="uom_rate"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <InputNumber placeholder="" style={{ width: "100%" }} />
                        </Form.Item>

                        <Form.Item
                            label="Qty"
                            name="qty"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <InputNumber placeholder="" style={{ width: "100%" }} disabled />
                        </Form.Item>
                        <Form.Item
                            label="Price"
                            name="price"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <InputNumber
                                placeholder=""
                                style={{ width: "100%" }}
                                formatter={numberFormatter}
                                parser={numberParser}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Sub Total"
                            name="sub_total"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <InputNumber
                                placeholder=""
                                style={{ width: "100%" }}
                                readOnly
                                formatter={numberFormatter}
                                parser={numberParser}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Discount"
                            name="discount"
                            style={{
                                marginBottom: "5px",
                            }}
                        >

                            <InputNumber
                                placeholder=""
                                style={{ width: "100%" }}
                                min={0}
                                max={100}
                                addonAfter="%"
                                disabled={isDiscountDisabled}
                                parser={(value) => (value ? Number(value.replace(',', '.')) : 0)}
                            />

                        </Form.Item>
                        <Form.Item
                            label="Discount Amount"
                            name="discount_amount"
                            style={{
                                marginBottom: "5px",
                            }}
                        >

                            <InputNumber
                                placeholder=""
                                style={{ width: "100%" }}
                                formatter={value => !value ? '0' : `${Math.round(Number(value))}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={numberParser}
                            />

                        </Form.Item>
                        <Form.Item
                            label="Total"
                            name="total"
                            style={{
                                marginBottom: "5px",
                            }}
                        >

                            <InputNumber
                                placeholder=""
                                style={{ width: "100%" }}
                                readOnly
                                formatter={value => !value ? '0' : `${Math.round(Number(value))}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={numberParser}
                            />

                        </Form.Item>
                        <Form.Item
                            label="Remark"
                            name="remark"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input.TextArea rows={5} />
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 10, span: 14 }} style={{ marginTop: "20px" }}>
                            <Space>
                                <Button type="primary" htmlType="submit">
                                    OK
                                </Button>
                                <Button onClick={onCancel}>
                                    Cancel
                                </Button>
                            </Space>
                        </Form.Item>

                    </Form>

                </div>
            </div>
        </div>
    );
};

export default EditTablePurchaseOrder;